/* global Image */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useRef, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { getPrintNotes } from "../utils/api/SocialRemote";
import classNames from "classnames";
import Icon from "./Icon";
var isImage = function(name) {
    return /\.(png|jpg|jpeg|svg)$/i.test(name.toLowerCase());
};
var buildAsset = function(asset) {
    return '\n      <li class="print-note__asset">\n        '.concat(isImage(asset.name) ? '<img class="print-note__image" src="'.concat(asset.path, '" alt="').concat(asset.name, '" title="').concat(asset.name, '" />') : "".concat(asset.name, " - ").concat(asset.path), "\n      </li>\n    ");
};
var loadImage = function(param) {
    var name = param.name, path = param.path, id = param.id;
    return new Promise(function(resolve, reject) {
        if (isImage(name)) {
            var img = new Image();
            img.onload = function() {
                resolve(id);
            };
            img.onerror = reject;
            img.src = path;
        } else {
            resolve(id);
        }
    });
};
var PrintNotesButton = function(param) {
    var intl = param.intl, _param_nodeIds = param.nodeIds, nodeIds = _param_nodeIds === void 0 ? [] : _param_nodeIds, nodeNames = param.nodeNames, cbookName = param.cbookName;
    var frame = useRef(null);
    var _useState = _slicedToArray(useState(false), 2), processing = _useState[0], setProcessing = _useState[1];
    useEffect(function() {
        if (frame.current) {
            var cssLink = (frame.current.contentDocument || frame.current.contentWindow.document).querySelector('link[href*="printNotes.css"]');
            if (!cssLink) {
                var addCSS = function(href) {
                    var el = document.createElement("link");
                    el.href = "".concat(href, "?").concat(+new Date());
                    el.rel = "stylesheet";
                    frame.current.contentDocument.head.appendChild(el);
                };
                addCSS("css/printNotes.css");
                addCSS("theme/theme.css");
                addCSS("theme/accessibility.css");
                addCSS("css/client.css");
                addCSS("css/last.css");
            }
        }
    });
    var print = function() {
        if (!frame.current) {
            return;
        }
        setProcessing(true);
        getPrintNotes().then(function(_notes) {
            var notes = nodeIds.length ? _notes.filter(function(n) {
                return n.node_ids.some(function(id) {
                    return nodeIds.indexOf(id) > -1;
                });
            }) : _notes;
            var allAssets = notes.map(function(n) {
                return n.assets || [];
            }).flat();
            var renderFrame = function() {
                if (frame.current) {
                    frame.current.contentDocument.body.innerHTML = "\n            <h1>".concat(intl.formatMessage({
                        id: "print.notesHeader",
                        defaultMessage: '{cbook, select, true {Your cBook Notes of "{cbookName}"} other {Your cBook Notes from Slide {nodeNames}}}'
                    }, {
                        cbook: !nodeNames,
                        nodeNames: nodeNames,
                        cbookName: cbookName
                    }), '</h1>\n            <ul class="print-notes">\n              ').concat(notes.map(function(n) {
                        return '\n                <li class="print-note">\n                  <h2 class="print-note__title">'.concat(n.title, '</h2>\n                  <div class="print-note__description">\n                    ').concat(n.description, '\n                  </div>\n                  <ul class="print-note__assets">\n                    ').concat(n.assets ? n.assets.map(buildAsset).join("") : "", "\n                  </ul>\n                </li>");
                    }), "\n            </ul>");
                    setTimeout(function() {
                        return frame.current.contentWindow.print();
                    }, 500);
                } else {
                    console.error("No iFrame present to print Notes");
                }
                setProcessing(false);
            };
            if (allAssets.length) {
                Promise.all(allAssets.map(loadImage)).then(renderFrame).catch(console.warn);
            } else {
                renderFrame();
            }
        }).catch(function(err) {
            setProcessing(false);
            console.error(err);
        });
    };
    var classes = classNames("social-app-options__btn", "social-app-options__btn--print", {
        "social-app-options__btn--loading": processing
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
        className: classes,
        onClick: print
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "print",
        size: "m"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "social-app-options__btn-text"
    }, intl.formatMessage({
        id: "print.print",
        defaultMessage: "Print"
    })), /*#__PURE__*/ React.createElement("iframe", {
        title: "print",
        src: "about:blank",
        ref: frame,
        style: {
            visibility: "hidden",
            height: 0,
            width: 0,
            border: 0,
            margin: 0
        }
    })));
};
export var Component = PrintNotesButton;
export default injectIntl(PrintNotesButton);
